import { createContext } from 'react';

import { InvoiceHistoryContextType } from '@/react_app/components/BillingUsage/InvoiceHistory/types';
import { OverviewContextType } from '@/react_app/components/BillingUsage/Overview/types';
import { PaymentMethodsContextType } from '@/react_app/components/BillingUsage/PaymentMethods/payment-methods-types';
import { SettingsContext as SettingsContextType } from '@/react_app/components/BillingUsage/Settings/settings-types';
import { UsageHistoryContextType } from '@/react_app/components/BillingUsage/UsageHistory/types';

export const OverviewContext = createContext<OverviewContextType | null>(null);
export const SettingsContext = createContext<SettingsContextType | null>(null);
export const UsageHistoryContext = createContext<UsageHistoryContextType | null>(null);
export const PaymentMethodContext = createContext<PaymentMethodsContextType | null>(null);
export const InvoiceHistoryContext = createContext<InvoiceHistoryContextType | null>(null);
